exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-interactive-programme-js": () => import("./../../../src/templates/interactive-programme.js" /* webpackChunkName: "component---src-templates-interactive-programme-js" */),
  "component---src-templates-production-programme-js": () => import("./../../../src/templates/production-programme.js" /* webpackChunkName: "component---src-templates-production-programme-js" */)
}

